import * as React from 'react';
import { useEffect, useMemo, useState } from 'react';
import { ThemeContext } from './ThemeContext';
import { Theme } from './types';

type Props = React.PropsWithChildren<{
  defaultTheme?: string;
}>;

export const ThemeContextProvider: React.FC<Props> = ({
  // @ts-ignore
  defaultTheme,
  // @ts-ignore
  children,
}) => {
  const [theme, setTheme] = useState<string>(defaultTheme || '');
  const contextValue = useMemo<Theme>(
    () => ({
      theme: theme,
      change: (name: string) => {
        setTheme(name);
      },
    }),
    [theme]
  );

  useEffect(() => {
    document.body.className = '';
    if (theme) {
      document.body.classList.add(theme);
    }
  }, [theme]);

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  );
};
